import React from "react";

export default function DictionaryTab({
  dictionaryEntries, dictionarySearchTerm, setDictionarySearchTerm,
  handleAddWordClick, isAddWordModalOpen, setIsAddWordModalOpen,
  newWord, setNewWord, handleAddWordSubmit,
  editingWordId, setEditingWordId, editingWordData, setEditingWordData,
  setDictionaryEntries, playWordAudio, handleDeleteWord,
}) {
  const filteredDictionary = dictionaryEntries.filter(entry =>
    (entry.word || '').toLowerCase().includes(dictionarySearchTerm.toLowerCase()) ||
    (entry.translation || '').toLowerCase().includes(dictionarySearchTerm.toLowerCase()) ||
    (entry.example || '').toLowerCase().includes(dictionarySearchTerm.toLowerCase())
  );

  // Новые слова сверху, показываем все
  const displayedDictionary = [...filteredDictionary].reverse();

  return (
    <div className="section-card dictionary-section-content">
      <div className="dictionary-header">
        <div className="dictionary-search-bar">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="search-icon">
            <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="currentColor"/>
          </svg>
          <input
            type="text"
            placeholder="Search dictionary..."
            value={dictionarySearchTerm}
            onChange={(e) => setDictionarySearchTerm(e.target.value)}
          />
        </div>
        <button className="add-new-words-btn" onClick={handleAddWordClick}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4V20M4 12H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>ADD NEW WORDS</span>
        </button>
      </div>

      {isAddWordModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Add New Word</h2>
              <button
                className="close-modal-btn"
                onClick={() => setIsAddWordModalOpen(false)}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <form onSubmit={handleAddWordSubmit} className="add-word-form">
              <div className="form-group">
                <input
                  type="text"
                  value={newWord}
                  onChange={(e) => setNewWord(e.target.value)}
                  placeholder="Enter word or phrase"
                  required
                  autoFocus
                  className="word-input"
                />
              </div>
              <div className="form-actions">
                <button type="button" onClick={() => setIsAddWordModalOpen(false)} className="cancel-btn">
                  Cancel
                </button>
                <button type="submit" className="submit-btn">
                  Add Word
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="dictionary-table-container">
        {filteredDictionary.length > 0 ? (
          <>
            <div className="dictionary-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Word</th>
                    <th>Level</th>
                    <th>Translation</th>
                    <th>Example</th>
                    <th>Lesson</th>
                    <th style={{ textAlign: "center" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedDictionary.map(entry => (
                    <tr key={entry.id}>
                      {editingWordId === entry.id ? (
                        <>
                          <td>
                            <input
                              value={editingWordData.word}
                              onChange={e => setEditingWordData({ ...editingWordData, word: e.target.value })}
                            />
                          </td>
                          <td>
                            <input
                              value={editingWordData.level}
                              onChange={e => setEditingWordData({ ...editingWordData, level: e.target.value })}
                            />
                          </td>
                          <td>
                            <input
                              value={editingWordData.translation}
                              onChange={e => setEditingWordData({ ...editingWordData, translation: e.target.value })}
                            />
                          </td>
                          <td>
                            <input
                              value={editingWordData.example}
                              onChange={e => setEditingWordData({ ...editingWordData, example: e.target.value })}
                            />
                          </td>
                          <td>{entry.lesson?.title}</td>
                          <td className="dictionary-actions">
                            <button
                              className="action-btn save-btn"
                              title="Save"
                              onClick={() => {
                                setDictionaryEntries(prev =>
                                  prev.map(w =>
                                    w.id === entry.id ? { ...w, ...editingWordData } : w
                                  )
                                );
                                setEditingWordId(null);
                              }}
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor"/>
                              </svg>
                            </button>
                            <button
                              className="action-btn cancel-btn"
                              title="Cancel"
                              onClick={() => setEditingWordId(null)}
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
                              </svg>
                            </button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <span>{entry.word}</span>
                              <button
                                className="audio-play-btn"
                                title="Play pronunciation"
                                onClick={() => playWordAudio(entry.word)}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  cursor: 'pointer',
                                  padding: '4px',
                                  borderRadius: '4px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: '#6c757d',
                                  transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.color = '#ee5a24';
                                  e.target.style.backgroundColor = 'rgba(238, 90, 36, 0.1)';
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.color = '#6c757d';
                                  e.target.style.backgroundColor = 'transparent';
                                }}
                              >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                                </svg>
                              </button>

                            </div>
                          </td>
                          <td>
                            <span className={`level-badge level-${entry.level}`}>
                              {entry.level}
                            </span>
                          </td>
                          <td>{entry.translation}</td>
                          <td>{entry.example}</td>
                          <td>{entry.lesson?.title}</td>
                          <td className="dictionary-actions">
                            <button
                              className="action-btn edit-btn"
                              title="Edit"
                              onClick={() => {
                                setEditingWordId(entry.id);
                                setEditingWordData({
                                  word: entry.word,
                                  level: entry.level,
                                  translation: entry.translation,
                                  example: entry.example
                                });
                              }}
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z" fill="currentColor"/>
                              </svg>
                            </button>

                            <button
                              className="action-btn delete-btn"
                              title="Delete"
                              onClick={() => handleDeleteWord(entry.id)}
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z" fill="currentColor"/>
                              </svg>
                            </button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <p className="no-lessons-message">No dictionary entries found.</p>
        )}
      </div>
    </div>
  );
}
